/**
 * Manifesto §02 — three-row "what Nyx does" with album-driven demos.
 *
 * Each pillar carries:
 *   - num    : "01 · Estructura" eyebrow text
 *   - accent : 'blue' | 'violet' | 'green' → maps to .nl-mf-row.is-{accent}
 *   - title  : the big claim ("Mapeamos la forma del álbum.")
 *   - body   : the qualifying line below the title
 *
 * The DEMO content (right column of each row) is sourced live from the
 * chosen album in <Manifesto> — the strings here are the only static copy.
 */

export const manifestoCopy = {
  eyebrow: '— Tres formas de escuchar de cerca',
  pillars: [
    {
      num: '01 · Estructura',
      accent: 'blue',
      title: 'Mapeamos la forma del álbum.',
      body: 'Giros, ascensos, retiradas, momentos clave. La forma completa del álbum, leída como sistema.',
    },
    {
      num: '02 · Significado',
      accent: 'violet',
      title: 'Leemos las letras de verdad.',
      body: 'Voz, símbolos, frases clave, lecturas alternativas. La canción leída entera.',
    },
    {
      num: '03 · En vivo',
      accent: 'green',
      title: 'Lo preparamos para el concierto.',
      body: 'La frase para sentir, el cambio de energía, la entrada al tema en vivo.',
    },
  ],
} as const;

export type ManifestoPillar = (typeof manifestoCopy.pillars)[number];
export type ManifestoAccent = ManifestoPillar['accent'];
